import './_c-button-tabs.scss';
import ButtonTabs from "./c-button-tabs";

nn.registerModule('buttonTabs', function (root) {
  return new ButtonTabs(root);
});
